/**
 * Round 42 D14 (`MY-TOOLS-2`): the `/my_tools` cards that name a capability INSIDE another page land on it.
 *
 * `MyToolsCatalog.java` points *Import a post* at `/create/discussion?tool=import` and *Featured on your
 * profile* at `/user/{you}?tool=featured`. The destination reads the param on mount and opens the thing the
 * card named (the composer's Import menu, the profile's curation dialog). No arrival copy: the decision was
 * to arrive at the capability rather than explain it.
 *
 * **Read-only, never written (rule 33).** Nothing here strips the param or writes history; a reader that
 * needs the value after a mount-time `canonicalize` (UserPage's `useHistoryBackedState` rebuilds the address
 * from its route state and drops unknown params) must capture it at its FIRST render.
 */
export const MY_TOOLS_ARRIVAL_PARAM = "tool";

/** The capabilities a `/my_tools` card can land on. Keep in step with `MyToolsCatalog.java`. */
export type MyToolsArrival = "import" | "featured";

/** The capability the address asks the page to open on arrival, or null. */
export function readMyToolsArrival(search: string): MyToolsArrival | null {
    const value = new URLSearchParams(search).get(MY_TOOLS_ARRIVAL_PARAM);
    return value === "import" || value === "featured" ? value : null;
}
